import { render, staticRenderFns } from "./otherBenefits.vue?vue&type=template&id=618ad5d1"
import script from "./otherBenefits.vue?vue&type=script&lang=js"
export * from "./otherBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports